import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { PageDataPanelComponent } from '../../../shared/page-layout/page-data-panel.component';
import { HrPayslip } from '../../../hr/hr.models';
import { MyHrWorkspaceService } from '../shared/my-hr-workspace.service';
import { labelize, statusSeverity } from '../shared/my-hr-workspace.utils';

@Component({
  selector: 'app-my-hr-payslips',
  standalone: true,
  imports: [CommonModule, TableModule, TagModule, PageDataPanelComponent],
  templateUrl: './my-hr-payslips.component.html',
  styleUrls: ['./my-hr-payslips.component.scss']
})
export class MyHrPayslipsComponent implements OnInit {
  private readonly workspaceService = inject(MyHrWorkspaceService);

  payslips: HrPayslip[] = [];

  ngOnInit(): void {
    this.workspaceService.loadPayslips().subscribe({
      next: payslips => {
        this.payslips = payslips;
      },
      error: () => {
        this.payslips = [];
      }
    });
  }

  get totalNet(): number {
    return this.payslips.reduce((total, payslip) => total + Number(payslip.netAmount || 0), 0);
  }

  label(value?: string): string {
    return labelize(value);
  }

  statusSeverity(value?: string): 'success' | 'secondary' | 'info' | 'warn' | 'danger' {
    return statusSeverity(value);
  }
}
